module.exports = __webpack_public_path__ + "assets/cash-out.cd7bb19ae162c6ccd9c604594f65966c.png";